import { json } from 'react-router-dom'

import ApiRoutes from '@utils/api-routes'
import http from '@utils/http'

import type { ErrorResponse } from '@utils/http'
import type { LoaderFunction } from 'react-router-dom'

export type EduPricingResponse = {
  learn_price: number
  min_users: number
}

export type PremiumPricingResponse = {
  monthly_price: number
  promotion_content_item_prefix: string | null
  promotion_coupon_code: string | null
  promotion_price: number | null
  yearly_price: number
}

export type PlansLoaderResponse = {
  premiumPricing: PremiumPricingResponse
  eduPricing: EduPricingResponse
}

const plansLoader: LoaderFunction = async () => {
  // If hash includes "/learn", redirect to "/commerce/purchase_learn"
  // This is to support legacy hash links like "/plans#/learn"
  if (window.location.hash.includes('/learn')) {
    return new Promise(() => {
      window.location.replace('/commerce/purchase_learn')
    })
  }

  const results = await Promise.allSettled([
    http.loader.post<PremiumPricingResponse>(ApiRoutes.apiPremiumSubPricingPath()),
    http.loader.post(ApiRoutes.apiLearnSubPricingPath()),
  ])

  let premiumPricing: PremiumPricingResponse | ErrorResponse | null = null
  if (results[0].status === 'fulfilled') {
    premiumPricing = results[0].value
  }

  let eduPricing: EduPricingResponse | ErrorResponse | null = null
  if (results[1].status === 'fulfilled') {
    eduPricing = results[1].value
  }

  // We don't defer loading here so that we can show the page when all the prices are loaded
  return json({ premiumPricing, eduPricing })
}

export default plansLoader
